// extracted by mini-css-extract-plugin
export default {"container":"UserNotFound_container__m4eW7","title":"UserNotFound_title__9JgR-"};